import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

//Components
import { Header } from './components/header/header.component';
import { Footer } from './components/footer/footer.component';
import { ProductView } from './components/product-view/product-view.component';
import { ActivityView } from './components/activity-view/activity-view.component';
import { ActivityRenderer } from  './components/activity-renderer/activity-renderer.component';
import { ActivityLaunch } from './components/activity-launch/activity-launch.component';
import { ActivityQuestion } from './components/activity-question/activity-question.component';
import { CollaborativeSkill } from './components/collaborative-skill/collaborative-skill.component';
import { ProductiveSkill } from './components/productive-skill/productive-skill.component';
import { TextEditor } from './components/text-editor/text-editor.component';
import { Recording } from './components/recording/recording.component';
import { SaveAlert } from './components/save-alert/save-alert.component';
import { SubmittedSpeakingPSkill } from './components/submitted-speaking-pskill/submitted-speaking-pskill.component';
import { ChangesNotSaved } from './components/changes-not-saved/changes-not-saved.component';
import { FloatToIntPipe } from './pipes/floatToInt.pipe';
import { ElapsedTimePipe } from './pipes/elapsedTime.pipe';
import { WordCountPipe } from './pipes/wordCount.pipe';
import { ResultScreen } from './components/result-screen/result-screen.component';
import { MessageBanner } from './components/message-banner/message-banner.component';


//Services
import { CustomTranslationLoader } from '../app/services/custom-translation-loader';
import { ProductViewService } from './services/product-view.service';
import { ActivityViewDataService } from './services/activity-view-data.service';
import { ActivityViewHelperService } from './services/activity-view-helper.service';
import { CanDeactivateLPGuard } from './services/can-deactivate-lp-guard.service';
import { RecordingHelperService } from './services/recording-helper.service';
import { SaveWarningGuard } from './services/save-warning-guard.service';
import { GetStreamCommentsService } from './services/getstream-comments.service';
import { GroupHelperService } from './services/groups-helper.service';
import { AudioPlayerService  } from './services/audio-player.service';
import { PushXService } from './services/pushx.service';
import { ContentAccessHelperService } from './services/content-access-helper.service';
import { TrackUserService } from './services/track-user.service';
import { A11yModule } from '@angular/cdk/a11y';

//Directives
import { OrderByPipe } from './pipes/order-by.pipe';
import { ImageThumbnailUpdate } from './directives/image-thumbnail-update';

@NgModule({
  declarations: [
    Header,
    Footer,
    ProductView,
    ActivityView,
    ActivityRenderer,
    ActivityLaunch,
    ActivityQuestion,
    CollaborativeSkill,
    FloatToIntPipe,
    ProductiveSkill,
    TextEditor,
    Recording,
    SaveAlert,
    SubmittedSpeakingPSkill,
    ChangesNotSaved,
    ElapsedTimePipe,
    WordCountPipe,
    OrderByPipe,
    ResultScreen,
    ImageThumbnailUpdate,
    MessageBanner
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslationLoader
      }
    }),
    RouterModule,
    FormsModule,
    A11yModule
  ],
  exports : [
    Header,
    Footer,
    ProductView,
    ActivityView,
    ActivityLaunch,
    OrderByPipe,
    ResultScreen,
    ImageThumbnailUpdate,
    MessageBanner
  ],
  providers: [
    ProductViewService,
    ActivityViewDataService,
    ActivityViewHelperService,
    CanDeactivateLPGuard,
    GetStreamCommentsService,
    GroupHelperService,
    RecordingHelperService,
    SaveWarningGuard,
    PushXService,
    ElapsedTimePipe,
    WordCountPipe,
    OrderByPipe,
    AudioPlayerService,
    TrackUserService,
    ContentAccessHelperService
  ]
})
export class SharedModule {
}
